<template>
  <div class="home">
    <!-- <MapList></MapList> -->
    <LoaderList v-if="LoaderList"></LoaderList>
    <video class="fullscreenvideo" poster="" id="bgvid" playsinline="" autoplay="" muted="" loop=""
      style=" width: 100%; height: 100%; resize: both; position: absolute;z-index: 0;top: 0px; left: 0%;">
      <source src="@/assets/images/banckground.mp4" type="video/mp4" />
    </video>
    <div id="bai-du-map" v-show="MapImg == true"></div>
    <!-- 顶部 -->
    <TopList></TopList>
    <Xianyu v-show="MapImg == false&&infoWindowzhen==false"></Xianyu>
    <div  v-show="MapImg == false&&infoWindowzhen==true" class="zhentop">{{xiangzhenName}} <i class="el-icon-circle-close" @click="mapClose"></i></div>
    <!-- 左边 -->
    <div class="leftList">
      <LeftList  v-if="MapImg == false" :filterList="filterList" ref="childRef"></LeftList>
      <leftTwoList v-else></leftTwoList>
    </div>
    <div class="middle">
      <el-tabs v-model="activeName" class="tabqiehuan" style="margin-left:36.5%" :style="{ '--color': imgUrl }" @tab-click="handleClick">
        <el-tab-pane label="宏观地图" name="first" >
          <!-- <img src="@/assets/images/mapImg.jpg" alt="" style="margin-top:150px" /> -->
        </el-tab-pane>
        <el-tab-pane label="实景地图" name="second">
          <img src="@/assets/images/open.png" alt="" @click="openDwo" class="openDwo" />
        </el-tab-pane>
      </el-tabs>
      <div v-show="MapImg == false" id="cityChart" ref="cityMap" style="background:none;" :style="{ width: '100%', height: '900px' }"></div>
      <!-- 图层管理 -->
      <div class="middle_tcglpag" v-show="MapImg == true">
        <transition :duration="{ enter: 500, leave: 800 }" enter-active-class="animate__animated animate__backInUp"
          leave-active-class="animate__animated animate__zoomOutDown" mode="out-in">
          <div id="middle_treecov" v-show="tcglCov">
            <div class="middle_tcgl" v-show="tcglCovTit">
              <div class="middle_tcgl_lf"><img src="@/assets/images/layers.png" alt="" class="middle_tcgl_lf_img" /></div>
              <span class="middle_tcgl_text">图层管理</span>
              <span class="middle_tcgl_small" @click="tcglDwo">折叠</span>
              <img src="@/assets/images/fold.png" alt="" @click="tcglDwo" class="middle_tcgl_lf_fold" />
            </div>
            <el-tabs type="border-card" v-model="tabActive" @tab-click="tabHandle">
              <el-tab-pane name="bearBody">
                <span slot="label"><i class="el-icon-s-home"></i> 承灾体</span>
                <div class="tree_box">
                  <el-tree ref="bearBodyTree" @check-change="bearBodyNode" default-expand-all :data="bearBody"
                    show-checkbox node-key="id" :props="defaultProps">
                  </el-tree>
                </div>
              </el-tab-pane>
              <el-tab-pane name="riskZone">
                <span slot="label"><i class="el-icon-s-ticket"></i> 风险区</span>
                <div class="tree_box">
                  <el-tree ref="riskZoneTree" default-expand-all :data="riskZone" @check-change="riskZoneNode" show-checkbox
                    node-key="id" :props="defaultProps">
                  </el-tree>
                </div>
              </el-tab-pane>
              <el-tab-pane name="reduceAble">
                <span slot="label"><i class="el-icon-s-marketing"></i> 减灾能力</span>
                <div class="tree_box">
                  <el-tree ref="reduceAbleTree" :data="reduceAble" default-expand-all @check-change="reduceAbleNode"
                    show-checkbox node-key="id" :default-expanded-keys="[2, 3]" :default-checked-keys="[5]"
                    :props="defaultProps">
                  </el-tree>
                </div>
              </el-tab-pane>
              <el-tab-pane name="reducexiangz">
                <span slot="label"><i class="el-icon-s-marketing"></i> 乡镇</span>
                <div class="tree_box">
                  <el-tree
                    ref="treezhen"
                    :data="overzhen"
                    show-checkbox
                    node-key="id"
                    :default-expanded-keys="xiangzhenChecked"
                    @check-change="townNode">
                  </el-tree>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </transition>
      </div>
    </div>
    <!-- 右边 -->
    <div class="rightList">
      <RightList v-if="MapImg == false" :filterList="filterList"></RightList>
      <rightTwoList @shili-List="handexamList" v-else></rightTwoList>
    </div>
    <!-- 地图自动跳转开关 -->
    <div style="position:absolute;bottom:30px;right:34%;z-index: 222;" v-if="MapImg == true">
        <span style="color:#fff;padding-right:10px;">地图自动播放</span>
        <el-switch
          v-model="valueTab"
          @change="swittab"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
    </div>
    <el-dialog title="" :visible.sync="dialogVisibleShop" width="70%" top="7vh" :append-to-body="true">
      <div class="shopTc">
        <span class="shopTc_tit">{{ listqeury.name }} <i class="el-icon-circle-close shopTc_show"
            @click="shopShowClose"></i>
        </span>
        <div class="shopTc_con">
          <span class="shopTc_con_name">主体名称： <span style="color:#E0E0E0;">{{ listqeury.name }}</span> </span>
          <span class="shopTc_con_name">详细地址： <span style="color:#E0E0E0;">{{ listqeury.address }}</span> </span>
        </div>
        <el-table :data="listqeury.fillItemList" height="485" border style="width: 96%;margin:0 auto;">
          <el-table-column prop="name" label="指标名称" width="180">
          </el-table-column>
          <el-table-column prop="itemCode" label="代码" width="180">
          </el-table-column>
          <el-table-column prop="itemValue" label="填报值">
          </el-table-column>
        </el-table>
        <div class="shopTc_bottom">
          <span class="shopTc_bottom_name">单位负责人： <span style="color:#E0E0E0;">{{ listqeury.headMen }}</span> </span>
          <span class="shopTc_bottom_name">填表人： <span style="color:#E0E0E0;">{{ listqeury.fillMen }}</span> </span>
          <span class="shopTc_bottom_name">联系电话： <span style="color:#E0E0E0;">{{ listqeury.mobilePhone }}</span> </span>
          <span class="shopTc_bottom_name">报出日期： <span style="color:#E0E0E0;">{{ listqeury.fillTime }}</span> </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisibleJzdd" width="70%" top="7vh" :append-to-body="true">
      <div class="shopTc">
        <span class="shopTc_tit">{{ listqeury.name }} <i class="el-icon-circle-close shopTc_show"
            @click="shopShowClose"></i>
        </span>
        <div class="shopTc_con">
          <el-select v-model="value" placeholder="请选择" @change="selectChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span style="color:#00e9ff;font-size:14px;">单位：m</span>
        </div>
        <el-table :data="jzddqeury" height="455" border style="width: 96%;margin:0 auto;">
          <el-table-column prop="name" label="周边资源" width="200">
          </el-table-column>
          <el-table-column prop="buildingTypeName" label="主体类型" width="251">
          </el-table-column>
          <el-table-column prop="distance" label="距离(m)" width="100">
          </el-table-column>
          <el-table-column prop="address" label="位置" width="400">
          </el-table-column>
          <el-table-column prop="mobilePhone" label="联系方式" width="180">
          </el-table-column>
          <el-table-column
            label="查看详情"
            width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.row)"
                type="text"
                size="small">
                查看详情
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="itemValue" label="查看详情" width="180">
          </el-table-column> -->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top:20px;margin-left:3%;">
        </el-pagination>
        <div class="shopTc_bottom">
          <span class="shopTc_bottom_name">单位负责人： <span style="color:#E0E0E0;">{{ listqeury.headMen }}</span> </span>
          <span class="shopTc_bottom_name">填表人： <span style="color:#E0E0E0;">{{ listqeury.fillMen }}</span> </span>
          <span class="shopTc_bottom_name">联系电话： <span style="color:#E0E0E0;">{{ listqeury.mobilePhone }}</span> </span>
          <span class="shopTc_bottom_name">报出日期： <span style="color:#E0E0E0;">{{ listqeury.fillTime }}</span> </span>
        </div>
      </div>
    </el-dialog>
    <!-- 3D地图弹窗 -->
    <div v-if="infoWindowzhen==true&&MapImg == false"  >
      <div class="infoWindowcyfz" v-if="filterList.length>0">
        <i class="el-icon-close icontop" style="color:#fff;" @click="mapClose"></i>
        <div class="container" v-for="(item, index) in filterList"  :key="index">
            <div class="title">{{item.name}}</div>
            <img v-if="item.img" :src="item.img" alt="" class="banner">
            <img v-else src="@/assets/images/zhenimg2.jpg" alt="" class="banner">
            <el-tooltip v-if="item.remark"  placement="top" effect="light" >
                <template #content>
                  <div style="width: 400px;">{{item.remark}}</div>
                </template>
              <p  class="showtext">{{item.remark}}</p>
            </el-tooltip>
            <p v-else class="showtext">暂无相关信息...</p>
            <div v-if="item.remark" @click="openChildDialog(item.id,item.name)" class="diaocbBtm">调查表</div>
        </div>
      </div>
    </div>
    <!-- 地图标点弹窗 -->
    <div ref="infoWindow" class="infoWindow">
      <div class="container" v-for="(item, index) in singleData" :key="index">
        <!-- 这里面写弹窗布局样式 -->
        <div class="addTc">
          <span class="addTc_tit">基本信息 <i class="el-icon-circle-close smallCHU" id="smallCHUId" @click="smallCHU"></i>
            <!-- <span  class="addTc_show">详情>></span>  -->
          </span>
          <span class="addTc_gs">主体名称： 
            <el-tooltip v-if="item.name"  placement="top" effect="light" >
                <template #content>
                  <div style="min-width: 100px;">{{item.name}}</div>
                </template>
                <span style="color:#E0E0E0;">{{ item.name }}</span>
            </el-tooltip>
          </span>
          <span class="addTc_gs">详细地址： 
            <el-tooltip v-if="item.address"  placement="top" effect="light" >
                <template #content>
                  <div style="min-width: 100px;">{{item.address}}</div>
                </template>
                <span style="color:#E0E0E0;">{{ item.address }}</span> 
            </el-tooltip>
          </span>
          <!-- <span class="addTc_gs">成立时间： <span style="color:#E0E0E0;"></span> </span> -->
          <span class="addTc_gs">负 责 人： <span style="color:#E0E0E0;">{{ item.contactMen }} {{ item.mobilePhone }}</span>
          </span>
          <div class="addTcBtn">
              <div class="addTcBtn_lf" @click="shopShow(item)">调查表</div>
              <div class="addTcBtn_rt" @click="jzddShow(item)">精准调度</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索框 -->
    <div class="addselect" v-show="MapImg == true">
      <el-select
        v-model="valuesele"
        filterable
        clearable
        placeholder="请输入关键词搜索"
        @change="addselt"
        @clear="cleadd"
        popper-class="custom-select-dropdown"
      >
        <el-option
          v-for="item in optionssousuo"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 宏观地图标注 -->
    <div class="hguanbote" v-if="MapImg == false">
      <div class="notelist">
          <div class="sekuai"></div>
          <span>东部洪水灾害综合风险区</span>
      </div>
      <div class="notelist">
          <div class="sekuai" style="background:#57ccfd;"></div>
          <span>西部洪水-干旱-冰雹-台风-雪灾综合风险区</span>
      </div>
    </div>
    <!-- 实景地图标注 -->
    <div class="shijbote" v-else>
      <div class="notelist" v-for="(item,index) in examList" :key="index">
          <img :src="item.icon"  alt="" class="sekuai">
          <span >{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

import { init } from 'echarts';
import ScaleBox from 'vue2-scale-box';

import {
  queryAreaInfoByAreaInfoIds,
  queryBuildingInfoByTypeIds,
  queryBuildingInfoWithSurveyRecored,
  queryMapLayerData,
} from '@/api/mapRequery';
// @ is an alias to /src
import { queryBuildingInfoByDistance , queryDivisionInfoList} from '@/api';
import AMapLoader from '@amap/amap-jsapi-loader';
import zigong from '../utils/map.json';

// 设置安全密钥
window._AMapSecurityConfig = {
  securityJsCode: '9717000b582173f89bc34178c30f8837',
}

export default {
  name: "HomeView",
  components: {
    ScaleBox,
  },
  data() {
    return {
      xiangzhenChecked: [1,1],
      activeName: 'first', //3d 实景切换
      imgUrl:'url(data:image/png;base64,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)',//切换地图 样式
      tabActive: 'bearBody', // 图层管理切换
      bearBody: [], //承载体
      riskZone: [], //风险区
      reduceAble: [], //减灾能力
      reducexiangz:[], //乡镇
      bearBodycheck: [],
      riskAreacheck: [],
      reduceAblecheck: [],
      areaIdList: [], // 承载体 默认数据
      riskIdList: [],// 风险区 默认数据
      reduceIdList: [], // 减灾能力 默认数据
      gpsSiteList: [],
      regionList: [],
      gpsSiteShow: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      listqeury: {
        principalName: '',
        address: '',
        mobilePhone: '',
        headMen: '',
        fillMen: '',
        fillItemList: [],
      },
      jzddqeury:[],
      // 地图
      map: null,
      mouseTool: null,
      overlays: [],
      auto: null,
      placeSearch: null,
      // 地图结束
      MapImg: false,
      dialogVisible: false,
      dialogVisibleShop: false,
      dialogVisibleJzdd:false,
      dialogVisibleMap:false,
      cityChart: null, //3D图片
      tcglCov: false,
      tcglCovTit: false,
      markerPoint: ref({}),
      polygonPoint: ref({}),
      markerPoints: ref({}),
      infoWindow: null,
      cluster: null,
      IndexDataList: '',
      singleData: [],
      LoaderList: true,
      bakimg: '',
      current:1,
      size:10,
      total:10,
      distanceRange:10000,
      jjddList:'',
      searchBuildingInfoId:'',
       options: [{
          value: '100',
          label: '100'
        }, {
          value: '1000',
          label: '1000'
        }, {
          value: '3000',
          label: '3000'
        }, {
          value: '10000',
          label: '10000'
        }, {
          value: '50000',
          label: '50000'
        }],
      value: '',
      xiangzhenName:'',
      gkList:[
        {
          text:'慎城镇是安徽省颍上县下辖的一个镇，成立于2005年11月8日。由颍河乡、城关镇以及夏桥镇的四个行政村（沙北、朱岗、杨台、江岗）组成。该镇位于颍上县委、县政府所在地，是全县政治、经济、文化、信息中心和交通枢纽。',
          img:require('@/assets/images/zhenimg1.jpg')
        },
        {
          text:'慎城镇是颍上县委、县政府所在地，全县政治、经济、文化、信息中心和交通枢纽。全镇14个农业村，22个社区，15.3万口人，地域面积108.8平方公里。慎城镇以汉族为主，少数民族有回族、维吾尔族、藏族。境内有沙颍河、宋沟湖、柳沟、五里湖、曹池沟五大水系及流域，土地高低悬殊，沙淤、沙土和黏土相间，适合各种农作物。',
          img:require('@/assets/images/zhenimg2.jpg')
        },
        {
          text:'慎城镇经济发展优势主要有三个方面：一是农业基础优势。辖区内有阜阳市万亩蔬菜生产基地、小麦高产攻关田基地、畜禽养殖基地。绿色产品迎春小酥瓜、三岔沟萝卜、管氏面粉系列、米万连禽蛋，通过网络远销全国各地。2007年实现工农业总产值2.6亿元，同比增长6.3%，完成土地治理面积1500亩，实现农民人均纯收入2600元；二是交通区位优势。',
          img:require('@/assets/images/zhenimg3.jpg')
        }
      ],
      // 搜索框
      optionssousuo: [],
      valuesele:'',
      loading: false,
      // 乡镇树状数据
      overzhentree:[{
        id: 1,
        init: false,
        label: '全部乡镇',
        children: [{
          id: 11,
          label: '慎城镇',
          eaname:'shenCheng',
        },{
          id: 12,
          label: '谢桥镇',
          eaname:'xieqiao',
        },{
          id: 13,
          label: '南照镇',
          eaname:'nanzhao',
        },{
          id: 14,
          label: '杨湖镇',
          eaname:'yanghu',
        },{
          id: 15,
          label: '江口镇',
          eaname:'jiangkou',
        },{
          id: 16,
          label: '润河镇',
          eaname:'runhe',
        },{
          id: 17,
          label: '新集镇',
          eaname:'xinji',
        },{
          id: 18,
          label: '六十铺镇',
          eaname:'liushipu',
        },{
          id: 19,
          label: '耿棚镇',
          eaname:'gengpeng',
        },{
          id: 20,
          label: '半岗镇',
          eaname:'bangang',
        },{
          id: 21,
          label: '王岗镇',
          eaname:'wanggang',
        },{
          id: 22,
          label: '夏桥镇',
          eaname:'xiaqiao',
        },{
          id: 23,
          label: '江店孜镇',
          eaname:'jiangdainzhi',
        },{
          id: 24,
          label: '陈桥镇',
          eaname:'chenqiao',
        },{
          id: 25,
          label: '黄桥镇',
          eaname:'huangqiao',
        },{
          id: 26,
          label: '八里河镇',
          eaname:'balihe',
        },{
          id: 27,
          label: '迪沟镇',
          eaname:'digou',
        },{
          id: 28,
          label: '西三十铺镇',
          eaname:'xishanshipu',
        },{
          id: 29,
          label: '红星镇',
          eaname:'hongxingzhen',
        },{
          id: 30,
          label: '十八里铺镇',
          eaname:'shibalipu',
        },{
          id: 31,
          label: '鲁口镇',
          eaname:'lukou',
        },{
          id: 32,
          label: '古城镇',
          eaname:'gucheng',
        },{
          id: 33,
          label: '建颍乡',
          eaname:'jianyin',
        },{
          id: 34,
          label: '五十铺乡',
          eaname:'wushilipu',
        },{
          id: 35,
          label: '盛堂乡',
          eaname:'shengtang',
        },{
          id: 36,
          label: '关屯乡',
          eaname:'guantun',
        },{
          id: 37,
          label: '垂岗乡',
          eaname:'chuigang',
        },{
          id: 38,
          label: '赛涧回族乡',
          eaname:'saijianhuizhu',
        },{
          id: 39,
          label: '刘集乡',
          eaname:'liuji',
        },{
          id: 40,
          label: '黄坝乡',
          eaname:'huangba',
        }]
      }],
      filterList:[],
      infoWindowzhen:false,
      townList:{},
      tucengList:null,//选择镇跟其他选项关联
      mapValueList:[],//地图公共列表
      overzhen:[],//构造镇的数组 
      valueTab:true,//控制地图自动显示
      intervalId: null,        // 控制地图自动显示存储 interval ID
      counter: 0 ,              // 控制地图自动显示计数器示例
      markerAdd:null,
      arradd:[116.256949, 32.653628],
      examList:[]
    };
  },
  created() {
    this.$nextTick(() => { // 加载echarts图
      this.listViwedate();
      setTimeout(() => {
        this.LoaderList = false;
      }, 4000)
    })
    
  },
  mounted() {
    // this.myEcharts();
    this.$nextTick(() => { // 加载echarts图
      this.initMap();//高德地图
      this.getCityMap();
      this.mapApi(this.valueTab);
    })
  },
  methods: {
    handexamList(e){
      let nameming = e.nameList.map(item=>({name:item}))
      let iconList = e.imgList.map(item=>({icon:item}))
      let examListnum = []
      nameming.forEach((element,index) => {
        examListnum.push({
          name:element.name,
          icon:iconList[index].icon
        })
      });
      this.examList = examListnum
    },
    // 3D地图跳转
    openChildDialog(id,name) {
      this.$refs.childRef.openDialog(id,name)
    },
    // 切换地图自动显示开关
    swittab(e){
      this.mapApi(e);
    },
    // 停止定时器
    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
        if (this.intervalId== null) {
          queryDivisionInfoList().then(val=>{
              this.mapValueList = val.data
              let users2 = val.data
              let users1 = this.overzhentree[0].children
              users1 = users1.map(res=>{
                  users2.map(lit=>{
                    if (lit.name == res.label) {
                      res = {...res,...lit}
                    }
                  })
                  return res
              })
              this.overzhen = [{
                id: 1,
                init: false,
                label: '全部乡镇',
                children:users1
              }]
              // 自动跳转各个镇
              if (this.overzhen) {
               this.$refs.treezhen.setChecked(users1[1].id, true, false);
                this.areaLiandong();//风险区
                this.bearBodyLiandong();//承灾体
                this.jianzaiLiandong();//减灾能力分析联动
              }
              // 自动跳转各个镇结束
          })
        }
      }
    },
    // 地图列表接口
    mapApi(etab){
      queryDivisionInfoList().then(val=>{
          this.mapValueList = val.data
          let users2 = val.data
          let users1 = this.overzhentree[0].children
          users1 = users1.map(res=>{
              users2.map(lit=>{
                if (lit.name == res.label) {
                  res = {...res,...lit}
                }
              })
              return res
          })
          this.overzhen = [{
            id: 1,
            init: false,
            label: '全部乡镇',
            children:users1
          }]
          // 自动跳转各个镇
          if (this.overzhen) {
            // 先停止可能存在的旧定时器
            this.stopInterval()
            this.intervalId = setInterval (() => {
              this.counter++
              // 取消当前选中的节点
              if (this.$refs.treezhen&&etab) {
                this.$refs.treezhen.setCheckedKeys([]);
                 // 获取 tree 实例并手动触发事件
                const randomIndex = Math.floor(Math.random() * users1.length)
                this.$refs.treezhen.setChecked(users1[randomIndex].id, true, false);
                this.areaLiandong();//风险区
                this.bearBodyLiandong();//承灾体
                this.jianzaiLiandong();//减灾能力分析联动
              }
            }, 3000);
          }
          // 自动跳转各个镇结束
      })
    },
    // 搜索框
    addselt(val){
      queryBuildingInfoByTypeIds(this.areaIdList.join(',')).then((res) => {
        res.data.map((item) => {
          if (item.id==val) {
            let arr = item.gpsSite.split(',')
            this.markerAdd = new AMap.Marker({
              map: this.map,
              position: [arr[0], arr[1]], // 经纬度
              // offset: new AMap.Pixel(15, 10),
              icon: new AMap.Icon({
                      size: new AMap.Size(25, 30),    // 图标尺寸
                      image: item.iconUrl,  // Icon的图像
                      imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
                      imageSize: new AMap.Size(25, 30)   // 根据所设置的大小拉伸或压缩图片
                    }), // 添加 Icon 图标 URL（不加icon应该有默认标记）
              extData: item
            });
            this.markerAdd.on('click', (e) => {
              this.singleData = []
              //这里通过e.target._opts.extData和item.id进行比对，如果相同则把这项点的信息单独放一个数组里去遍历，就是html里的遍历数组
              if (e.target._opts.extData.id === item.id) {
                this.singleData.push(item)
              }
              let position = e.target.getPosition();
              let zoomLevel = 16; // 放大级别
              this.$nextTick(() => {
                this.map.setZoomAndCenter(zoomLevel, position);
              });
              this.infoWindow.open(this.map, e.target.getPosition())
            })
            let position = arr;
            let zoomLevel = 18; // 放大级别
            this.$nextTick(() => {
              this.map.setZoomAndCenter(zoomLevel, position);
            });
            }
          
        })
      })
    },
    // 清除搜索内容
    cleadd(){
      if (this.markerAdd) {
         this.map.remove(this.markerAdd); 
          this.markerAdd = null;
          let zoomLevel = 11; // 放大级别
          this.$nextTick(() => {
            this.map.setZoomAndCenter(zoomLevel, [116.256949, 32.653628]);
          });
      }
     
      // this.mapApi(this.valueTab);
    },
    // 图层管理数据列表
    listViwedate() {
      queryMapLayerData().then((res) => {
        this.bearBody = res.data.bearBodyTree; // 承载体
        res.data.bearBodyTree.map((item) => {
          this.bearBodycheck.push(item.id)
        })
        this.riskZone = res.data.riskAreaTree; //风险区
        res.data.riskAreaTree.map((item) => {
          this.riskAreacheck.push(item.id)
        })
        this.reduceAble = res.data.reduceAbleTree //减灾能力
        res.data.reduceAbleTree.map((item) => {
          this.reduceAblecheck.push(item.id)
        })
        setTimeout(() => {
          this.$refs.bearBodyTree.setCurrentKey(this.bearBodycheck.join(','));
          this.$refs.bearBodyTree.setCheckedKeys(this.bearBodycheck);
          this.$refs.riskZoneTree.setCurrentKey(this.riskAreacheck.join(','));
          this.$refs.riskZoneTree.setCheckedKeys(this.riskAreacheck);
          this.$refs.reduceAbleTree.setCurrentKey(this.reduceAblecheck.join(','));
          this.$refs.reduceAbleTree.setCheckedKeys(this.reduceAblecheck);
        })
      })
    },
    // 承灾体点击
    bearBodyNode(data, checked, node) {
      const customerRangeId = this.$refs.bearBodyTree.getCheckedNodes(true).map((item) => {
        let json = {
          id: item.id,
        };
        return json;
      });
      this.areaIdList = customerRangeId.map((item, index) => {
        return item.id
      })
      this.bearBodyLiandong();
    },
    //承载体联动显示
    bearBodyLiandong(){
      let divIds = this.$refs.treezhen.getCheckedKeys();
      let bearBodyTree = this.$refs.bearBodyTree.getCheckedKeys();
      Object.keys(this.markerPoint).map(key=>{
        
        let building = this.markerPoint[key];
        building.map(b => {
          var has = false;
          divIds.map(va => {
            bearBodyTree.map(m => {
              if(va == b.getExtData().divisionInfoId && key == m){
                b.show();
                has = true;
              }
            })
          })
          if(!has){
            b.hide();
          }
        })
        
      })
    },
    // 风险区点击
    riskZoneNode(data, checked, node) {
      const customerRangeId = this.$refs.riskZoneTree.getCheckedNodes(true).map((item) => {
        let json = {
          id: item.id,
        };
        return json;
      });
      
      this.riskIdList = customerRangeId.map((item, index) => {
        return item.id
      })
      this.areaLiandong();
    },
    // 减灾能力点击
    reduceAbleNode(data, checked, node) {
      const customerRangeId = this.$refs.reduceAbleTree.getCheckedNodes(true).map((item) => {
        let json = {
          id: item.id,
        };
        return json;
      });
      this.reduceIdList = customerRangeId.map((item, index) => {
        return item.id
      })
      this.jianzaiLiandong();
    },
    //减灾能力联动显示
    jianzaiLiandong(){
      let divIds = this.$refs.treezhen.getCheckedKeys();
      let reduceAbleTree = this.$refs.reduceAbleTree.getCheckedKeys();
      Object.keys(this.markerPoints).map(key=>{
        let building = this.markerPoints[key];
        building.map(b => {
          var has = false;
          divIds.map(va => {
            reduceAbleTree.map(m => {
              if(va == b.getExtData().divisionInfoId && key == m){
                b.show();
                has = true;
              }
            })
          })
          if(!has){
            b.hide();
          }
        })
      })
    },
    // 乡镇图层管理点击
    townNode(data, checked, node){
      if (data.eaname) {
        this.addPolygon(data,checked);
      }
    },
    // 点击乡镇的显隐
    addPolygon(data,checked,aa,bb) {
      //控制乡镇区域显示
      const randomColor = this.getRandomColor();
      let divIds = this.$refs.treezhen.getCheckedKeys();
      divIds.map(val => {
        if(!this.townList[val]){ 
            let m = null;
            this.mapValueList.map(mapdata => {
              if(val == mapdata.id){
                m = mapdata;
              }
            });
            if(m){
              this.townList[val] = new AMap.Polygon({
                path: JSON.parse(m.rangePoint),
                fillColor: randomColor,
                strokeOpacity: 1,
                fillOpacity: 0.4,
                strokeColor: '#ffffff',
                strokeWeight: 1,
                strokeStyle: 'dashed',
                strokeDasharray: [5, 5],
                extData:m
              });
              this.map.add(this.townList[val] )
            }
        }
      })
      Object.keys(this.townList).map(val =>{
        var has = false;
        divIds.map(v => {
          if(v == val){
            this.townList[val].show();
            has = true;
          }
        })
        if(!has){this.townList[val].hide();}
      }) 
     this.areaLiandong();//风险区
     this.bearBodyLiandong();//承灾体
     this.jianzaiLiandong();//减灾能力分析联动
    },
    //风险区域联动显示
    areaLiandong(){
      let divIds = this.$refs.treezhen.getCheckedKeys();
      let riskZoneTree = this.$refs.riskZoneTree.getCheckedKeys();
      Object.keys(this.polygonPoint).map(key=>{
        this.polygonPoint[key].map(val => {
          var has = false;
          divIds.map(v => {
            riskZoneTree.map(r => {
              if(v == val.getExtData().id && key == r){
                val.show();
                has = true;
              }
            });
          })
          if(!has){
           val.hide();
          }
        })
      })
    },
    // 随机颜色
    getRandomColor() {
      // 生成随机颜色的函数
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    // 开始自动选
    tcglDwo() {
      this.tcglCovTit = false
      this.tcglCov = false
    },
    openDwo() {
      this.tcglCovTit = true
      this.tcglCov = true

      // if (this.tcglCovTit == false) {
      //   this.tcglCov = false
      // }
    },
    myEcharts() {
      var line = this.$echarts.init(document.getElementById("line"));
      //配置图表
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: '20%',
          icon: 'circle',
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          data: ['高风险区域', '中风险区域', '低风险区域', '水旱灾害区', '其他']
        },
        series: [
          {
            name: '风险区域',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              color: '#fff'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              },
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 50,
                name: '高风险区域',
                itemStyle: {
                  normal: {
                    color: 'rgba(53,130,247,0.6)',
                    borderColor: 'rgba(53,130,247,0.8)',
                    borderWidth: 3,
                    shadowColor: 'rgba(53,130,247,0.8)',
                    shadowBlur: 10
                  }
                }
              },
              {
                value: 30,
                name: '中风险区域',
                itemStyle: {
                  normal: {
                    color: 'rgba(244,201,7,0.5)',
                    borderColor: 'rgba(244,201,7,0.8)',
                    borderWidth: 3,
                    shadowColor: 'rgba(244,201,7,0.8)',
                    shadowBlur: 10
                  }
                }
              },
              {
                value: 20,
                name: '低风险区域',
                itemStyle: {
                  normal: {
                    color: 'rgba(25,236,176,0.5)',
                    borderColor: 'rgba(25,236,176,0.8)',
                    borderWidth: 3,
                    shadowColor: 'rgba(25,236,176,0.8)',
                    shadowBlur: 10
                  }
                }
              },
              {
                value: 10,
                name: '水旱灾害区',
                itemStyle: {
                  normal: {
                    color: 'rgba(134,66,255,0.6)',
                    borderColor: 'rgba(134,66,255,0.8)',
                    borderWidth: 3,
                    shadowColor: 'rgba(134,66,255,0.8)',
                    shadowBlur: 10
                  }
                }
              },
              {
                value: 10,
                name: '其他',
                itemStyle: {
                  normal: {
                    color: 'rgba(30, 210, 255, 0.6)',
                    borderColor: 'RGBA(19, 136, 212, 0.8)',
                    borderWidth: 3,
                    shadowColor: 'RGBA(19, 136, 212, 0.8)',
                    shadowBlur: 10
                  }
                }
              }
            ],
            center: ['35%', '50%']
          }
        ]
      };
      line.setOption(option);
    },
    handleClick(tab, event) {
      if (tab.label == '宏观地图') {
        this.MapImg = false
        this.imgUrl = 'url(data:image/png;base64,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)'
      } else {
        this.MapImg = true
        this.imgUrl = 'url(data:image/png;base64,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)'
        
      }
    },
    tabHandle(tab, event) {
      console.log(tab.name);
    },
    shopShow(val) {
      this.dialogVisible = false
      this.dialogVisibleShop = true
      this.infoWindow.close()
      queryBuildingInfoWithSurveyRecored(val.id).then((res) => {
        this.listqeury = res.data
      })
    },
    selectChange(val){
      this.distanceRange = Number(val)
      let dalist = {
        "current": this.current,
        "distanceRange": this.distanceRange,
        "searchBuildingInfoId": this.searchBuildingInfoId,
        "size": this.size,
      }
      this.jjddList = val
      queryBuildingInfoByDistance(dalist).then((res) => {
        this.jzddqeury = res.data.records
        this.total = res.data.total
      })
    },
    handleSizeChange(val) {
      this.size = val
      let dalist = {
        "current": this.current,
        "distanceRange": this.distanceRange,
        "searchBuildingInfoId": this.searchBuildingInfoId,
        "size": this.size,
      }
      this.jjddList = val
      queryBuildingInfoByDistance(dalist).then((res) => {
        this.jzddqeury = res.data.records
        this.total = res.data.total
      })
    },
    handleCurrentChange(val) {
      this.current = val
      let dalist = {
        "current": this.current,
        "distanceRange": this.distanceRange,
        "searchBuildingInfoId": this.searchBuildingInfoId,
        "size": this.size,
      }
      this.jjddList = val
      queryBuildingInfoByDistance(dalist).then((res) => {
        this.jzddqeury = res.data.records
        this.total = res.data.total
      })
    },
    jzddShow(val) {
      this.dialogVisible = false
      this.dialogVisibleJzdd = true
      this.infoWindow.close()
      this.shopShow(val);
      this.searchBuildingInfoId = val.id
      let dalist = {
        "current": this.current,
        "distanceRange": this.distanceRange,
        "searchBuildingInfoId": val.id,
        "size": this.size,
      }
      this.jjddList = val
      queryBuildingInfoByDistance(dalist).then((res) => {
        this.jzddqeury = res.data.records
        this.total = res.data.total
      })
    },
    deleteRow(val) {
      this.dialogVisibleJzdd = false
      this.dialogVisibleShop = true
      this.infoWindow.close()
      queryBuildingInfoWithSurveyRecored(val.id).then((res) => {
        this.listqeury = res.data
      })
    },
    // 镇的关闭
    shopShowClose() {
      this.dialogVisibleShop = false
      this.dialogVisibleShow = false
      this.dialogVisibleJzdd = false
      this.dialogVisibleMap = false
      this.infoWindowzhen = false
    },
    mapClose(){
      this.infoWindowzhen = false
      this.filterList = [
        {
          id:'0'
        }
      ]
    },
    initMap() {
      // 确保容器存在
      if (!document.getElementById('bai-du-map')) {
        console.error('地图容器未找到');
        return;
      }
      AMapLoader.load({
        "key": "47da8a3f3ca516ecef00f9c05bf015fb",
        "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        "plugins": [],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // 初始化地图
        this.map = new AMap.Map('bai-du-map', {
          viewMode: "2D",  //  是否为3D地图模式
          zoom: 11,   // 初始化地图级别
          center: [116.256949, 32.653628], //中心点坐标  
          mapStyle: 'amap://styles/darkblue',
          dragEnable: true,//地图是否可通过鼠标拖拽平移，默认为true。此属性可被setStatus/getStatus 方法控制
          jogEnable: true,//地图是否使用缓动效果，默认值为true。此属性可被setStatus/getStatus 方法控制
          keyboardEnable: true,//地图是否可通过键盘控制,默认为true方向键控制地图平移，"+"和"-"可以控制地图的缩放，Ctrl+“→”顺时针旋转，Ctrl+“←”逆时针旋转。此属性可被setStatus/getStatus 方法控制
          animateEnable: true,//地图平移过程中是否使用动画（如调用panBy、panTo、setCenter、setZoomAndCenter等函数，将对地图产生平移操作，是否使用动画平移的效果），默认为true，即使用动画
          defaultCursor: 'pointer',
          turboMode: false,
          showBuildingBlock: true,//设置地图显示3D楼块效果，移动端也可使用。推荐使用。
          showIndoorMap: false, // 隐藏地图自带的室内地图图层
          expandZoomRange: true,//是否支持可以扩展最大缩放级别,和zooms属性配合使用设置为true的时候，zooms的最大级别在PC上可以扩大到20级，移动端还是高清19/非高清20
          forceVector: true,
          scale: (2, 2.5),
        });
        // 地图加载完以后再加载点位等信息
        this.map.on('complete', () => {
          // 实景地图
          setTimeout(() => {
            this.init1("颍上县");
            this.listMapDate();
          }, 400)
          // 实景地图结束
        });
        //自定义信息窗体
        this.infoWindow = new AMap.InfoWindow({
          isCustom: true,
          autoMove: false,
          avoid: [20, 20, 20, 20],
          content: this.$refs.infoWindow,
          closeWhenClickMap: true,
          offset: new AMap.Pixel(20, -15)
        })
      }).catch(e => {
      });
    },
    smallCHU(e) {
      this.infoWindow.close()
    },
    init1(city) {//区域遮盖
      var that = this
      if (that.polygon) {
        that.map.remove(that.polygon)
      }
      new AMap.plugin('AMap.DistrictSearch', function () {
        new AMap.DistrictSearch({
          extensions: 'all',
          subdistrict: 0
        }).search(city, function (status, result) {// 外多边形坐标数组和内多边形坐标数组
          var outer = [
            new AMap.LngLat(-360, 90, true),
            new AMap.LngLat(-360, -90, true),
            new AMap.LngLat(360, -90, true),
            new AMap.LngLat(360, 90, true)
          ]
          var holes = result.districtList[0].boundaries
          var pathArray = [outer]
          pathArray.push.apply(pathArray, holes)
          that.polygon = new AMap.Polygon({
            pathL: pathArray,
            strokeColor: '#00eeff',//城市边界颜色
            strokeWeight: 3,
            fillColor: '#71B3ff', // 遮罩背景色黑色
            fillOpacity: 0.2
          })
          that.polygon.setPath(pathArray)
          that.map.add(that.polygon)
        })
      })
    },
    // 地图标记点
    listMapDate() {
      queryBuildingInfoByTypeIds(this.areaIdList.join(',')).then((res) => {
        this.optionssousuo = res.data
        res.data.map((item) => {
          let arr = item.gpsSite.split(',')
          if(!this.markerPoint[item.buildingTypeId]){
            this.markerPoint[item.buildingTypeId] = [];
          }
          let marker = new AMap.Marker({
            map: this.map,
            position: [arr[0], arr[1]], // 经纬度
            // offset: new AMap.Pixel(15, 10),
            icon: new AMap.Icon({
                    size: new AMap.Size(25, 30),    // 图标尺寸
                    image: item.iconUrl,  // Icon的图像
                    imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
                    imageSize: new AMap.Size(25, 30)   // 根据所设置的大小拉伸或压缩图片
                  }), // 添加 Icon 图标 URL（不加icon应该有默认标记）
            extData: item
          });
          marker.on('click', (e) => {
            this.singleData = []
            //这里通过e.target._opts.extData和item.id进行比对，如果相同则把这项点的信息单独放一个数组里去遍历，就是html里的遍历数组
            if (e.target._opts.extData.id === item.id) {
              this.singleData.push(item)
            }
            let position = e.target.getPosition();
            let zoomLevel = 12; // 放大级别
            this.$nextTick(() => {
              this.map.setZoomAndCenter(zoomLevel, position);
            });
            this.infoWindow.open(this.map, e.target.getPosition())
          })
          this.markerPoint[item.buildingTypeId].push(marker);
        })
      })
      // 区域围栏
      queryAreaInfoByAreaInfoIds(this.riskIdList.join(',')).then((res) => {
        res.data.map((item) => {
            if (!this.polygonPoint[item.id]) {
              this.polygonPoint[item.id]=[]
            }
            this.polygonPoint[item.id].push(new AMap.Polygon({
              map: this.map,
              path: JSON.parse(item.rangePoint), // 设置多边形边界路径
              strokeColor: item.color,
              strokeWeight: 2, // 线宽
              fillColor: item.color, // 填充色
              fillOpacity: 0.2, // 填充透明度
              cursor: item.color,
              extData: {
                title: item.name,
                id:item.divisionInfoId
              },
            }))
          })
      })
      // 减灾能力点
      queryBuildingInfoByTypeIds(this.reduceIdList.join(',')).then((res) => {
        res.data.map((item) => {
          let arr = item.gpsSite.split(',')
            if(!this.markerPoints[item.buildingTypeId]){
              this.markerPoints[item.buildingTypeId] = [];
            }
            let marker = new AMap.Marker({
              map: this.map,
              position: [arr[0], arr[1]], // 经纬度
              // offset: new AMap.Pixel(15, 10),
              icon: new AMap.Icon({
                      size: new AMap.Size(25, 30),    // 图标尺寸
                      image: item.iconUrl,  // Icon的图像
                      imageOffset: new AMap.Pixel(0, 0),  // 图像相对展示区域的偏移量，适于雪碧图等
                      imageSize: new AMap.Size(25, 30)   // 根据所设置的大小拉伸或压缩图片
                    }), // 添加 Icon 图标 URL（不加icon应该有默认标记）
              extData: item
            });
            marker.on('click', (e) => {
              this.singleData = []
              //这里通过e.target._opts.extData和item.id进行比对，如果相同则把这项点的信息单独放一个数组里去遍历，就是html里的遍历数组
              if (e.target._opts.extData.id === item.id) {
                this.singleData.push(item)
              }
              let position = e.target.getPosition();
              let zoomLevel = 12; // 放大级别
              this.$nextTick(() => {
                this.map.setZoomAndCenter(zoomLevel, position);
              });
              this.infoWindow.open(this.map, e.target.getPosition())
            })
            this.markerPoints[item.buildingTypeId].push(marker);
          })
      })
    },
    // 地图3D
    getCityMap() {
     
      this.cityChart = this.$echarts.init(this.$refs.cityMap);
      this.$echarts.registerMap("zigong", zigong);
      let option1 = {
        tooltip: {
          // 鼠标是否可以进入悬浮框
          enterable: false,
          // 触发方式 mousemove, click, none, mousemove|click
          triggerOn: 'click',
          // item 图形触发， axis 坐标轴触发， none 不触发
          trigger: 'item',
          // 浮层隐藏的延迟
          hideDelay: 800,
          // 背景色
          backgroundColor: '#0F82B6',
          formatter(params) {
            const mapNmae = params.name
            // return params.name
          },
        },
        textStyle: {
          color: "#ffffff", // 高亮时标签颜色变为 白色
          fontSize: 16, // 高亮时标签字体 变大
        },
        
        series:[{
            type: "map3D",
            map: "zigong",
            roam: true, //开启鼠标缩放和平移漫游。默认不开启
            //  后加
            roam: true, //开启鼠标缩放和平移漫游。默认不开启
            silent: false,
            regionHeight: 5, //修改整个地图的三维高度
            bottom: '8%', //距离底部的距离
            instancing: true,
             shading: "realistic",
            // 后加关闭
            show: false,
            roam: false,
            label: {
              show: true,
              color: '#ffffff',
            },
            // 地图样式和边界
            itemStyle: {
              color: "#05F5FD", // 背景颜色
              opacity: 1, //透明度
              borderWidth: 1,
              borderColor: "#03D9F3",
            },
            //鼠标放入高亮时地图板块的样式
            emphasis: {
              label: {
                show: true, //是否显示
                textStyle: {
                  color: '#ffffff',
                },
              },
              itemStyle: {
                color: '#ffffff' // 高亮颜色
              }
            },
            realisticMaterial: {
              detailTexture: require("@/assets/images/mapbak.png"), // 地图表面贴图
              textureTiling: 1, // 纹理平铺，1是拉伸，数字表示纹理平铺次数
              roughness: 1, // 材质粗糙度，0完全光滑，1完全粗糙
              metalness: 0, // 0材质是非金属 ，1金属
              roughnessAdjust: 0,
            },
            light: {
              main: {
                color: "#ff0000", //光照颜色
                intensity: 1, //光照强度
                shadowQuality: 'high', //阴影亮度
                shadow: true, //是否显示阴影
                shadowQuality: "medium", //阴影质量 ultra //阴影亮度
                alpha: 0,
                beta: 0,
              },
              ambient: {
                intensity: 1,
              },
            },
            zlevel: 5,
            silent: false,
            viewControl: {
              projection: "perspective", // 投影方式
              autoRotate: true, // 是否开启地图自动旋转
              autoRotateDirection: "cw", // 地图自动旋转的方向
              autoRotateSpeed: 5, // 地图自动旋转的速度
              autoRotateAfterStill: 2, // 鼠标离开后多少秒自动开启旋转
              damping: 0, // 鼠标进行旋转，缩放等操作时延迟时间
              rotateSensitivity: 10, // 旋转操作的灵敏度
              zoomSensitivity: 10, // 缩放操作的灵敏度
              panSensitivity: 10, // 平移操作的灵敏度
              panMouseButton: "left", // 平移操作使用的鼠标按键
              rotateMouseButton: "left", // 旋转操作使用的鼠标按键
              distance: 180, // 默认视角距离主体的距离
              minDistance: 40, // 视角通过鼠标控制能拉近到主体的最小距离
              maxDistance: 145, // 视角通过鼠标控制能拉远到主体的最大距离
              alpha: 40, // 视角绕 x 轴，即上下旋转的角度
              beta: 15, // 视角绕 y 轴，即左右旋转的角度
              minAlpha: -720, // 上下旋转的最小 alpha 值
              maxAlpha: 720, // 上下旋转的最大 alpha 值
              minBeta: -720, // 左右旋转的最小 beta 值
              maxBeta: 720, // 左右旋转的最大 beta 值
              center: [0, 0, 0], // 视角中心点
              animation: true, // 是否开启动画
              animationDurationUpdate: 1000, // 过渡动画的时长
              animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果

            },
            data:this.generateRandomData(zigong)
          },]
         
      };
      this.cityChart.setOption(option1);
      this.cityChart.off('click');// 跟2D地图添加点击事件相比多了这行代码
      this.cityChart.on('click', (e) => {
        this.xiangzhenName = e.name
        this.filterList = this.mapValueList.filter(lit=>{
          return lit.name===e.name
        })
        if (this.filterList) {
          this.infoWindowzhen = true
        }
      })
    },
     generateRandomData(mapData) { 
      // 为每个区域生成随机数据，用于决定颜色
      let data = mapData.features.map(feature => {
        return {
          name:feature.properties.name,
          itemStyle:{
            color:feature.color?feature.color:'#ff0000'
          }
        };
      })
      return data;
    },
    arrowClick(val) {
      if(val === 'next') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
  },
  beforeDestroy() {
    //清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.cityChart) {
      this.cityChart.dispose(); // 清理echarts实例
    }
  }
};
</script>

<style  scoped>
@import "@/assets/css/index.css";

.addTc_gs {
  text-align: left;
}

.tree_box {
  height: 700px;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  width: 5px;
  background-color: #f1f1f1;
  border-radius: 5px;
  display: none;
}

::-webkit-scrollbar-thumb {
  background-color: #888888c9;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>
<style  lang="less">
#bai-du-map {
  overflow: hidden;
  width: 100%;
  height: 1000px;
  margin: 0;
  position: absolute;
  z-index: 1;
  margin-top: 5vw;
}

.amap-copyright {
  opacity: 0;
}

.amap-logo {
  display: none;
}


</style>
